<template>
    <div class="integration-box">
        <div class="d-flex align-items-center flex-wrap">
            <img :src="require('@/assets/optima.svg')" />
            <button v-if="status" type="button"
                class="h-100 btn btn-primary export equipment ml-0 ml-sm-4 mt-2 mt-sm-0 h-40px w-100px">
                {{ $t('optima.active') }}
            </button>
            <button v-else type="button" class="h-40px btn btn-secondary close-btn ml-4 mt-2 mt-sm-0">
                {{ $t('optima.inactive') }}
            </button>
        </div>
        <p class="mt-3 text-tertiary">
            {{ $t('optima.description') }}
        </p>
        <div v-if="status">
            <div class="d-flex align-items-center flex-wrap mb-3" v-for="(item, index) in buttonsData" :key="index">
                <div>
                    <p class="mb-0">{{ $t(item.titleKey) }}</p>
                    <button @click="setSyncData(item.link)" type="button" :disabled="item.status === true ? false : true"
                        class="h-40px btn btn-primary export equipment mt-2 w-100px text-white">
                        {{ $t('optima.syncData') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between buttons-section flex-wrap">
            <div>
                <b-button type="button" v-if="status" class="w-125px h-40px" variant="danger" @click="removeToken()">
                    {{ $t('optima.deactivate') }}
                </b-button>
                <b-button v-else class="border-0 assigned-equipment w-100px" variant="success"
                    @click="$bvModal.show('modal-optima-integration')">{{ $t('optima.activate') }}</b-button>
            </div>
            <button type="button" class="btn btn-secondary close-btn w-100px h-40px" @click="$emit('close')">
                {{ $t('optima.close') }}
            </button>
        </div>
        <b-modal id="modal-optima-integration" :header-bg-variant="'white'" header-class="border-none" no-close-on-backdrop
            :footer-class="'d-block p-3 m-0'" no-close-on-esc>
            <template #modal-header="{ close }">
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="text-center">
                <img :src="require('@/assets/optima.svg')" height="80" width="80"/>
            </div>
            <div class="mt-3">
                <b-form-group :label="$t('optima.apiKeyLabel')" class="text-left">
                    <b-form-input type="text" class="input" v-model="form.optima_ELD_API_key"></b-form-input>
                    <p v-if="errors && errors.optima_ELD_API_key" class="field-error">
                        {{ errors.optima_ELD_API_key[0] }}
                    </p>
                </b-form-group>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mr-3 btn cancel m-0" block @click="closePopup">{{ $t('optima.cancel') }}</b-button>
                    <b-button class="btn save mx-0 m-0" variant="primary" @click="saveOptimaData">{{ $t('optima.save') }}</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
    name: "Optima-Integration",
    props: ["status"],
    data() {
        return {
            form: {
                optima_ELD_API_key: "",
            },
            errors: {},
            showPassword: false,
            buttonsData: [
                {
                    titleKey: "optima.vehicles",
                    link: "sync-optima-ELD-vehicles",
                    status: true,
                    data: "Vehicle",
                },
                {
                    titleKey: "optima.drivers",
                    link: "sync-optima-ELD-drivers",
                    status: true,
                    data: "Driver",
                },
            ],
        };
    },
    methods: {
        ...mapActions([
            "setLoader",
            "setNotification",
            "setAssetsData",
            "getAssetsData",
            "updateCompany"
        ]),
        closePopup() {
            this.$bvModal.hide('modal-optima-integration')
            this.errors = {}
            this.form = {
                optima_ELD_API_key: "",
            }
        },
        async saveOptimaData() {
            try {
                this.errors = {}
                const nullKeys = this.checkNullValues({
                    optima_ELD_API_key: this.form.optima_ELD_API_key,
                });
                if (nullKeys.length === 0) {
                    delete this.company[0].logo
                    await this.updateCompany({
                        id: this.userCompany,
                        payload: { ...this.company[0], optima_ELD_API_key: this.form.optima_ELD_API_key, state: this.company[0].state.id },
                    });
                    await this.setNotification({
                        msg: this.$t('optima.integrationSuccess'),
                        type: "success",
                        color: "green",
                    });
                    this.closePopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('optima.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        async setSyncData(link) {
            try {
                this.setLoader(true);
                await this.setAssetsData(link);
                await this.setNotification({
                    msg: this.$t('optima.syncSuccess'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false);
            } catch (error) {
                this.setLoader(false);
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        async removeToken() {
            try {
                delete this.company[0].logo
                await this.updateCompany({
                    id: this.userCompany,
                    payload: { ...this.company[0], optima_ELD_API_key: "", state: this.company[0].state.id },
                });
                await this.setNotification({
                    msg: this.$t('optima.removeSuccess'),
                    type: "success",
                    color: "green",
                });
            }
            catch (e) {
                console.log(e)
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
    },
    computed: {
        ...mapGetters(["assetsData", "company", "userCompany"]),
    },
    mounted() { },
};
</script>
<style>
.integration-box,
.password-change-box {
    min-height: 430px;
    position: relative;
}

.integration-box .buttons-section,
.password-change-box .buttons-section {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
}

@media (max-width: 575px) {
    .integration-box {
        min-height: 500px;
    }
}
</style>
  